import BASE_URL from "components/BaseUrl/apiConfig";
import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/AuthNavbar";
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2";
import BlockUiOverlay from "components/Expense/BlockUiOverlay";
import foldericon from "assets/img/foldericon.png";

const GetDocuments = () => {
  const history = useHistory();
  const [documents, setDocuments] = useState([]);
  const [documentId, setDocumentId] = useState(0);
  const [documentCategory, setDocumentCategory] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [description, setDescription] = useState("");
  const [selectDate, setSelectedDate] = useState(new Date());
  const [currentDate] = useState(new Date());
  const formRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState("");
  const [documentCategoryId, setDocumentCategoryId] = useState();
  const [loading, setLoading] = useState(false);
  const setfocus = useRef(null);

  //Get Useid form localStorage
  const storedUserData = localStorage.getItem("userData");
  let userId = "";
  let userTypeId = "";

  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
    userTypeId = userData.userTypeId;
  }

  const fileInputRef = useRef(null);

  useEffect(() => {
    setfocus.current.focus();
    fetchDocuments();
    fetchDocumentsCategory();
  }, []);

  //Get Docuemnt Data
  const fetchDocuments = async () => {
    setLoading(true);
    fetch(`${BASE_URL}/api/Document/GetDocuments?UserId=${userId}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch documents.");
        }
        return response.json();
      })
      .then((data) => {
        setDocuments(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching documents:", error.message);
        // You can show a notification or handle the error in another way as needed
        setLoading(false);
      });
  };

  //Get Document Category Data
  const fetchDocumentsCategory = async () => {
    fetch(
      `${BASE_URL}/api/DocumentCategory/GetDocumentCategories?UserId=${userId}`
    )
      .then((Response) => Response.json())
      .then((data) => {
        setDocumentCategory(data);
      })
      .catch((error) => {
        console.error("Error Fetching data:", error);
      });
  };

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
    const selectedValue = event.target.value;
    if (selectedValue === "newDocumentCategory") {
      history.push("/addDocumentCategory");
    } else {
      const categoryId = parseInt(event.target.value);
      setDocumentCategoryId(categoryId);
      const selectedCategoryObj = documentCategory.find(
        (category) => category.documentCategoryId === categoryId
      );
      if (selectedCategoryObj) {
        setDescription(selectedCategoryObj.defaultText);
      }
    }
  };

  // Add the following function to handle date change
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files);
  };

  const handleDescriptionChanage = (event) => {
    setDescription(event.target.value);
  };

  //Clicked Submit button
  const handleSubmit = (e) => {
    e.preventDefault();
    if (documentId == 0) {
      // Check for blank fields and set focus
      let firstBlankField = null;
      const formElements = formRef.current.querySelectorAll(
        'input:not([type="hidden"]):not([value]), select:not([value])'
      );
      formElements.forEach((field) => {
        if (!firstBlankField && field.value.trim() === "") {
          firstBlankField = field;
        }
      });
      if (firstBlankField) {
        firstBlankField.focus();
        return; // Stop form submission if blank field found
      }
    }

    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("documentId", documentId);
    formData.append("description", description);
    formData.append("actualDate", selectDate.toISOString());
    formData.append("documentCategoryId", documentCategoryId);
    //formData.append('uploadDocument', selectedFile);

    // File type validation
    const allowedDocumentTypes = [
      "application/msword",
      "application/pdf",
      "application/vnd.ms-excel",
      "application/vnd.ms-powerpoint",
      "text/plain",
    ];
    const allowedImageTypes = ["image/png", "image/jpeg", "image/jpg"];

    const invalidFiles = [];

    // for (let i = 0; i < selectedFile.length; i++) {
    //     const file = selectedFile[i];
    //     if (!file || !file.type || (!allowedDocumentTypes.includes(file.type) && !allowedImageTypes.includes(file.type))) {
    //         invalidFiles.push(file);
    //     }
    // }

    if (documentId === 0 && selectedFile.length > 0) {
      for (let i = 0; i < selectedFile.length; i++) {
        const file = selectedFile[i];
        if (
          !file ||
          !file.type ||
          (!allowedDocumentTypes.includes(file.type) &&
            !allowedImageTypes.includes(file.type))
        ) {
          invalidFiles.push(file);
        }
      }
    }

    if (invalidFiles.length > 0) {
      Swal.fire(
        "Wrong file types!",
        "Only Word, PDF, Excel, PowerPoint and Txt documents or PNG, JPG, JPEG images are allowed.",
        "error"
      );
      return;
    }

    // Add each selected file to FormData
    for (let i = 0; i < selectedFile.length; i++) {
      formData.append("uploadDocument", selectedFile[i]);
    }
    setLoading(true);
    fetch(`${BASE_URL}/api/Document/InsertDocument`, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          // Document inserted successfully, you might want to update state or take other actions
          Swal.fire(
            "Uploaded success!",
            `Files ${documentId > 0 ? "updated" : "uploaded"} successfully.`,
            "success"
          );
          setDescription("");
          setSelectedCategory("");
          setSelectedFile(null);
          setSelectedDate(new Date());
          fetchDocuments();
          setFileImage();
          setDocumentId(0);
          // Clear selected files input
          fileInputRef.current.value = null;
          setLoading(false);
        } else {
          setLoading(false);
          // Document insertion failed
          Swal.fire(
            "Error!",
            `Failed to ${documentId > 0 ? "updated" : "uploaded"} document.`,
            "error"
          );
        }
      })
      .catch((error) => {
        setLoading(false);
        Swal.fire(
          "Error!",
          `An error occurred while ${
            documentId > 0 ? "updated" : "uploaded"
          } document.`,
          "error"
        );
      });
  };

  const [fileimg, setFileImage] = useState("");
  // here is the code of Edit Document
  const navigateUpdateDocument = (document) => {
    // Set selected document for editing and activate editing mode
    setDescription(document.description);
    setDocumentId(document.documentId);
    setSelectedCategory(document.documentCategoryId);
    setDocumentCategoryId(document.documentCategoryId);
    setSelectedDate(new Date(document.uploadDate));
    setFileImage(document.filePath);
    // You may need additional logic to handle file data if required
  };

  //Click view Button
  //Send DocumentId on viewDocument page
  const handleViewClick = (documentId) => {
    history.push({
      pathname: "/viewDocument",
      state: { documentId: documentId },
    });
  };

  //Delete document by documentId
  const DeleteDocument = (documentId, categoryName) => {
    Swal.fire({
      title: "Confirmation",
      text: `Are you sure you want to delete this ${categoryName} category document?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        fetch(
          `${BASE_URL}/api/Document/DeleteDocument?documentId=${documentId}`,
          {
            method: "POST",
          }
        )
          .then((response) => response.json())
          .then((data) => {
            if (data.success) {
              setLoading(false);
              Swal.fire(
                "Deleted!",
                "Files has been deleted successfully.",
                "success"
              );
              // You might want to update the documents list after deletion
              fetchDocuments();
            } else {
              setLoading(false);
              Swal.fire("Error!", "Failed to delete document.", "error");
            }
          })
          .catch((error) => {
            console.error("Error deleting document:", error);
            setLoading(false);
            Swal.fire(
              "Error!",
              "An error occurred while deleting document.",
              "error"
            );
          });
      }
    });
  };

  //Formate Date that get from database
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    // Pad single digits with leading zero
    const formattedDay = String(day).padStart(2, "0");
    const formattedMonth = String(month).padStart(2, "0");

    return `${formattedDay}/${formattedMonth}/${year}`;
  };

  const [searchQuery, setSearchQuery] = useState("");
  // Function to handle search input change
  const handleSearchInputChange = (e) => {
    setSearchQuery(e.target.value);
  };
  // Function to filter data based on search query
  const filterDocuments = documents.filter((item) =>
    item.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // const getDocumentName = (filePath) => {
  //     // Find the index of the underscore (_) character after 'wwwroot/Documents\'
  //     const underscoreIndex = filePath.indexOf('_', filePath.indexOf('wwwroot/Documents\\'));

  //     // Extract the document name from the file path
  //     const fileName = filePath.substring(underscoreIndex + 1);

  //     return fileName;
  // };

  // const getDocumentName = (filePath) => {
  //     // Split the filePath by commas to get an array of filenames
  //     const fileNames = filePath.split(',');

  //     // Process each filename and extract the document name
  //     const processedFileNames = fileNames.map(fileName => {
  //         // Trim any leading or trailing whitespace from the filename
  //         const trimmedFileName = fileName.trim();
  //         // Find the index of the underscore character after 'wwwroot/Documents\\'
  //         const underscoreIndex = trimmedFileName.indexOf('_', trimmedFileName.indexOf('wwwroot/Documents\\'));
  //         // Extract the document name from the filename
  //         const extractedFileName = underscoreIndex !== -1 ? trimmedFileName.substring(underscoreIndex + 1) : trimmedFileName;
  //         return extractedFileName;
  //     });

  //     // Join the processed filenames into a single string separated by commas
  //     const concatenatedFileNames = processedFileNames.join(',');

  //     return concatenatedFileNames;
  // };

  const getDocumentName = (filePath) => {
    // Check if filePath is defined
    if (filePath) {
      // Split the filePath by commas to get an array of filenames
      const fileNames = filePath.split(",");

      // Process each filename and extract the document name
      const processedFileNames = fileNames.map((fileName) => {
        // Trim any leading or trailing whitespace from the filename
        const trimmedFileName = fileName.trim();
        // Find the index of the underscore character after 'wwwroot/Documents\\'
        const underscoreIndex = trimmedFileName.indexOf(
          "_",
          trimmedFileName.indexOf("wwwroot/Documents\\")
        );
        // Extract the document name from the filename
        const extractedFileName =
          underscoreIndex !== -1
            ? trimmedFileName.substring(underscoreIndex + 1)
            : trimmedFileName;
        return extractedFileName;
      });

      // Join the processed filenames into a single string separated by commas
      const concatenatedFileNames = processedFileNames.join(",");

      return concatenatedFileNames;
    } else {
      return ""; // Return an empty string if filePath is undefined
    }
  };

  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const togglePopover = () => {
    setIsPopoverOpen(!isPopoverOpen);
  };

  return (
    <>
      <BlockUiOverlay visible={loading} />
      <Navbar />
      <div className="cust-div min-h-content-minvh">
        <div className="container mx-auto p-4">
          <div className="flex justify-between items-center mb-4 flex-wrap">
            <h1 className="text-2xl  font-bold">Documents Library</h1>
            <input
              type="text"
              value={searchQuery}
              placeholder="Search here"
              style={{ height: "35px" }}
              onChange={handleSearchInputChange}
              className="!border-2 border-blueGray-300"
            ></input>
          </div>
          {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4"> */}
          <form ref={formRef} onSubmit={handleSubmit}>
            {/* <div className="flex justify-between flex-wrap md:flex-row w-full"> */}
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-2">
                <select
                  value={selectedCategory}
                  onChange={handleCategoryChange}
                  ref={setfocus}
                  className="custom-height !border-2 border-blueGray-300 mr-2 mb-1 w-full"
                >
                  <option disabled value="">
                    Select Category
                  </option>
                  {documentCategory
                    .sort((a, b) => a.name.localeCompare(b.name)) // Sort the array by the 'name' property
                    .map((category) => (
                      <option
                        key={category.documentCategoryId}
                        value={category.documentCategoryId}
                      >
                        {category.name}
                      </option>
                    ))}

                  {userTypeId != 3 ? (
                    <>
                      <option
                        value="newDocumentCategory"
                        style={{
                          background: "green",
                          color: "white",
                          border: "none",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                      >
                        Add New Category.
                      </option>
                    </>
                  ) : null}
                </select>
              </div>
              <div className="col-span-3">
                <input
                  type="text"
                  id="description"
                  name="description"
                  value={description}
                  onChange={handleDescriptionChanage}
                  className="form-control custom-height mb-1 !border-2 border-blueGray-300"
                  placeholder="Description"
                  maxLength={150}
                />
              </div>
              <div className="col-span-2">
                <DatePicker
                  selected={new Date(selectDate)}
                  onChange={handleDateChange}
                  className="form-control custom-height datepicker !border-2 border-blueGray-300" //custom-datepicker
                  dateFormat="dd/MM/yyyy"
                  maxDate={currentDate}
                  style={{ zIndex: 9999 }}
                />
              </div>
              <div className="col-span-3">
                <input
                  type="file"
                  onChange={handleFileChange}
                  ref={fileInputRef}
                  name="uploadDocument"
                  className="form-control custom-height border-input bg-white px-3 py-2 mr-2 text-sm text-gray-400 file:border-0 file:bg-transparent file:text-gray-600 file:text-sm file:font-medium !border-2 !border-blueGray-300"
                  multiple
                />

                {fileimg && (
                  <div
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    <img
                      src={foldericon}
                      alt="Folder Icon"
                      title="Click to view documents"
                      style={{
                        width: "20px",
                        height: "20px",
                        marginTop: "9px",
                        marginRight: "9px",
                        cursor: "pointer",
                      }}
                      onClick={togglePopover}
                    />
                    {isPopoverOpen && (
                      <div
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: "50%",
                          transform: "translateX(-50%)",
                          backgroundColor: "white",
                          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                          padding: "8px",
                          borderRadius: "4px",
                          zIndex: 9999,
                        }}
                      >
                        {getDocumentName(fileimg)
                          .split(",")
                          .map((chunk, index) => (
                            <div key={index}>{chunk}</div>
                          ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div className="col-span-2">
                <div className="">
                  <button
                    className="text-white uppercase custom-height text-xs font-bold active:bg-green-600 px-4 mb-1 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 quantity-button !w-full"
                    type="submit"
                    title={
                      documentId > 0 ? "Update Document" : "Upload Document"
                    }
                  >
                    {documentId > 0 ? "Update" : "Upload"}
                  </button>
                </div>
              </div>
            </div>
            {/* <select
              value={selectedCategory}
              onChange={handleCategoryChange}
              style={{ width: "144px" }}
              ref={setfocus}
              className="custom-height  mr-2 mb-1 w-1/4"
            >
              <option disabled value="">
                Select Category
              </option>
              {documentCategory
                .sort((a, b) => a.name.localeCompare(b.name)) // Sort the array by the 'name' property
                .map((category) => (
                  <option
                    key={category.documentCategoryId}
                    value={category.documentCategoryId}
                  >
                    {category.name}
                  </option>
                ))}

              {userTypeId != 3 ? (
                <>
                  <option
                    value="newDocumentCategory"
                    style={{
                      background: "green",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    Add New Category.
                  </option>
                </>
              ) : null}
            </select> */}
            {/* <input
              type="text"
              id="description"
              name="description"
              value={description}
              onChange={handleDescriptionChanage}
              className="form-control custom-height document-description mr-2 mb-1 w-1/4"
              placeholder="Description"
              maxLength={150}
            /> */}
            {/* <DatePicker
              selected={new Date(selectDate)}
              onChange={handleDateChange}
              className="form-control custom-height datepicker mr-2 custom-datepicker mb-1 w-1/4"
              dateFormat="dd/MM/yyyy"
              maxDate={currentDate}
              style={{ zIndex: 9999 }}
            /> */}
            {/* <input
              type="file"
              onChange={handleFileChange}
              ref={fileInputRef}
              name="uploadDocument"
              className="rounded-md border border-input bg-white px-3 py-1 mr-2 text-sm text-gray-400 file:border-0 file:bg-transparent file:text-gray-600 file:text-sm file:font-medium"
              style={{
                height: "35px",
                width: "224px",
                border: "1px solid",
              }}
              multiple
            />

            {fileimg && (
              <div style={{ position: "relative", display: "inline-block" }}>
                <img
                  src={foldericon}
                  alt="Folder Icon"
                  title="Click to view documents"
                  style={{
                    width: "20px",
                    height: "20px",
                    marginTop: "9px",
                    marginRight: "9px",
                    cursor: "pointer",
                  }}
                  onClick={togglePopover}
                />
                {isPopoverOpen && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: "50%",
                      transform: "translateX(-50%)",
                      backgroundColor: "white",
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                      padding: "8px",
                      borderRadius: "4px",
                      zIndex: 9999,
                    }}
                  >
                    {getDocumentName(fileimg)
                      .split(",")
                      .map((chunk, index) => (
                        <div key={index}>{chunk}</div>
                      ))}
                  </div>
                )}
              </div>
            )} */}

            {/* <div className="justify-end">
              <button
                className="text-white uppercase text-xs font-bold active:bg-green-600 px-4 py-2 mb-1 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 quantity-button"
                type="submit"
                title={documentId > 0 ? "Update Document" : "Upload Document"}
              >
                {documentId > 0 ? "Update" : "Upload"}
              </button>
            </div> */}
            {/* </div> */}
          </form>
          {/* </div> */}
          <div className="overflow-x-auto">
            <table className="w-full min-w-full ">
              <tbody>
                <tr className="border-b bg-lightBlue-500 text-white">
                  <td className="cell py-2 px-4 font-bold">Category </td>
                  <td className="cell py-2 px-4 font-bold">Description</td>
                  <td className="cell py-2 px-4 font-bold">Actual Date</td>
                  <td className="cell py-2 px-4 font-bold">Uploaded Date</td>
                  <td className="cell py-2 px-4 font-bold">Documents</td>
                  <td
                    className="cell py-2 px-4 font-bold"
                    style={{ float: "inline-end" }}
                  >
                    Action
                  </td>
                </tr>
                {filterDocuments && filterDocuments.length > 0 ? (
                  filterDocuments.map((document) => {
                    // Assuming document.filePath contains the file paths
                    // const filePaths = document.filePath.split(',');

                    // // Remove the common prefix "wwwroot/Documents/"
                    // const cleanedFilePaths = filePaths.map(path => path.replace('wwwroot/Documents/', ''));

                    // // Count the total number of images based on comma delimiter
                    // const imageCount = cleanedFilePaths.length;

                    // // Create a tooltip with all image names
                    // const tooltipText =  cleanedFilePaths;
                    // console.log(tooltipText);

                    // Assuming document.filePath contains the file paths
                    const filePaths = document.filePath.split(",");

                    // Remove the common prefix "wwwroot/Documents/" and extract file names
                    const fileNames = filePaths.map((path) => {
                      const fileNameWithExtension = path.split("/").pop();
                      return fileNameWithExtension.substring(
                        fileNameWithExtension.indexOf("_") + 1
                      );
                    });

                    // Count the total number of images based on comma delimiter
                    const imageCount = fileNames.length;

                    // Create a tooltip with all image names
                    const tooltipText = fileNames.join(", ");

                    return (
                      <tr
                        key={document.documentId}
                        className="hover:bg-gray-100 border-b"
                      >
                        <td className="cell py-1 px-4">
                          {document.categoryName}
                        </td>
                        <td className="cell py-1 px-4">
                          {document.description}
                        </td>
                        <td className="cell py-1 px-4">
                          {formatDate(document.actualDate)}
                        </td>
                        <td className="cell py-1 px-4">
                          {formatDate(document.createdOn)}
                        </td>
                        <td className="cell py-1 px-4" title={tooltipText}>
                          {imageCount}
                        </td>
                        <td className="cell py-1 px-4 flex justify-end">
                          <img
                            title="Edit"
                            src={require("assets/img/Editicon.png")}
                            alt="Edit"
                            className="mr-2 cursor-pointer"
                            style={{ width: "20px" }}
                            onClick={() => navigateUpdateDocument(document)}
                          />
                          <img
                            title="View"
                            src={require("assets/img/Viewicon.png")}
                            alt="View"
                            className="mr-2 cursor-pointer"
                            style={{ width: "20px" }}
                            onClick={() => handleViewClick(document.documentId)}
                          />

                          <img
                            title="Delete"
                            src={require("assets/img/deleteicon.png")}
                            alt="Delete"
                            className="cursor-pointer"
                            style={{ width: "20px" }}
                            onClick={() =>
                              DeleteDocument(
                                document.documentId,
                                document.categoryName
                              )
                            }
                          />
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      className="cell py-2 px-4"
                      colSpan="6"
                      style={{ textAlign: "center" }}
                    >
                      No documents are available here.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default GetDocuments;
